"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDeviceContext = void 0;
const react_1 = __importDefault(require("react"));
exports.defaultDeviceContext = {
    browser: {
        major: undefined,
        name: undefined,
        version: undefined,
    },
    ua: '',
    cpu: {
        architecture: undefined,
    },
    device: {
        model: undefined,
        type: undefined,
        vendor: undefined,
    },
    engine: {
        name: undefined,
        version: undefined,
    },
    os: {
        name: undefined,
        version: undefined,
    },
};
const DeviceContext = react_1.default.createContext(exports.defaultDeviceContext);
exports.default = DeviceContext;
//# sourceMappingURL=DeviceContext.js.map